<template>
  <div class="sidebar-container">
    <div style="padding: 12px 0 11px; text-align: center; border-bottom: 1px solid #f3f3f3">
      <img src="../../../../assets/platform_logo.png" height="40px" />
    </div>
    <el-scrollbar wrapClass="scrollbar-wrapper" style="flex: 1; border-right: 2px solid #edf0f7">
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        background-color="#FFFFFF"
        text-color="#B3BDC9"
        active-text-color="#263E6A"
      >
        <sidebar-item></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './sidebarItem'

export default {
  components: { SidebarItem }
}
</script>

<style lang="scss">
.sidebar-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  width: 190px !important;
  height: 100%;
  font-size: 0;
  background: #fff;
  transition: width 0.28s;

  /* reset element-ui css */
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden;
    width: 188px;

    .el-scrollbar__view {
      height: 100%;
    }
  }

  .scrollbar-wrapper::-webkit-scrollbar {
    display: none;
  }

  .is-horizontal {
    display: none;
  }

  a {
    display: inline-block;
    overflow: hidden;
    width: 100%;
  }

  .svg-icon {
    margin-right: 16px;
    font-size: 20px;
  }

  .el-menu {
    width: 100% !important;
    height: 100%;
    border: none;
  }
}
</style>
